import { Button } from "antd";
import { Link } from "react-router-dom";

const EmptyCart = ()=>{
    return(
        <div className="container mx-auto">
            <div className="flex justify-center items-center flex-col">
                <img src="/assets/img/photos/tk-shopping-img.png" alt="" />
                <div className="pt-2"><span className="text-signature">Nhoằm nhoằm</span><span>không tìm thấy sản phẩm nào trong giỏ hàng của bạn.</span></div>
                <Button className="mt-2" danger type="primary"><Link to={'/menu'}>Đặt món ngay</Link></Button>
            </div>
        </div>
    )
}
export default EmptyCart;